import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12a0e343"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "scorecard-topics-container",
  "data-test-tag": "ts-nps-scorecard"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "topic-label" }, "scorecard topics", -1))
const _hoisted_4 = { class: "sc-results" }
const _hoisted_5 = {
  key: 0,
  class: "sc-table"
}
const _hoisted_6 = {
  key: 0,
  class: "sc-label-row"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "topic-title" }
const _hoisted_9 = {
  key: 0,
  class: "sc-group-nps"
}
const _hoisted_10 = { class: "sc-nps" }
const _hoisted_11 = {
  key: 0,
  class: "uk-text-center uk-text-muted sc-no-results"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "99" }, "No results found", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "sc-legend"
}
const _hoisted_15 = { class: "legend-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key-circle positive" }, null, -1))
const _hoisted_17 = { class: "legend-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key-circle negative" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TsDatatypeSelector = _resolveComponent("TsDatatypeSelector")!
  const _component_NPSBarLabel = _resolveComponent("NPSBarLabel")!
  const _component_TsNpsCounts = _resolveComponent("TsNpsCounts")!
  const _component_NPSBar = _resolveComponent("NPSBar")!
  const _component_FormattedNumber = _resolveComponent("FormattedNumber")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.scorecardGroups && _ctx.scorecardGroups.tsgroups)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_TsDatatypeSelector, {
            current: _ctx.viewSelected,
            datatypes: _ctx.viewOptions,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewSelected = $event))
          }, null, 8, ["current", "datatypes"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.scorecardGroups && _ctx.scorecardGroups.tsgroups)
        ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              (_ctx.scorecardGroups.tsgroups.length > 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                    _createElementVNode("td", {
                      class: _normalizeClass({ 'sc-group-comparison': !_ctx.showCounts })
                    }, [
                      (!_ctx.showCounts)
                        ? (_openBlock(), _createBlock(_component_NPSBarLabel, {
                            key: 0,
                            class: "sc-bar-label",
                            min: Number(_ctx.scorecardGroups.minNPS),
                            max: Number(_ctx.scorecardGroups.maxNPS),
                            average: 
                                    Number(_ctx.insightsDetails.aggregateScore)
                                
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.scorecardGroups.isFiveScore
                                        ? 'Rating'
                                        : 'NPS') + " " + _toDisplayString(_ctx.scorecardGroups.isFiveScore
                                        ? Number(
                                              _ctx.insightsDetails.aggregateScore
                                          ).toFixed(4)
                                        : Number(
                                              _ctx.insightsDetails.aggregateScore
                                          ).toFixed(1)), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["min", "max", "average"]))
                        : _createCommentVNode("", true)
                    ], 2),
                    (!_ctx.showCounts)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_7, " "))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayScorecardGroups, (scorecardGroup) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: scorecardGroup.group
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass({
                                'sc-group-comparison': !_ctx.showCounts,
                                'sc-counts-container': _ctx.showCounts,
                            })
                  }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.scorecardGroupName(scorecardGroup.group)), 1),
                    (_ctx.showCounts)
                      ? (_openBlock(), _createBlock(_component_TsNpsCounts, {
                          key: 0,
                          "show-bg": "",
                          "count-positive": 
                                    Number(scorecardGroup.respondedPromoter)
                                ,
                          "count-negative": 
                                    _ctx.getThingsToWorkOnCount(scorecardGroup)
                                ,
                          "max-responded": 
                                    Number(
                                        _ctx.scorecardGroups.maxRespondedPromoterDetractor
                                    )
                                
                        }, null, 8, ["count-positive", "count-negative", "max-responded"]))
                      : (_openBlock(), _createBlock(_component_NPSBar, {
                          key: 1,
                          nps: Number(scorecardGroup.NPS),
                          min: Number(_ctx.scorecardGroups.minNPS),
                          max: Number(_ctx.scorecardGroups.maxNPS),
                          average: 
                                    Number(_ctx.insightsDetails.aggregateScore)
                                
                        }, null, 8, ["nps", "min", "max", "average"]))
                  ], 2),
                  (!_ctx.showCounts)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createTextVNode(_toDisplayString(scorecardGroup.NPS) + " ", 1),
                          (scorecardGroup.previousNPS)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([
                                        'sc-delta',
                                        {
                                            up: scorecardGroup.scoreDelta > 0,
                                            down:
                                                scorecardGroup.scoreDelta <= 0,
                                        },
                                    ])
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_ctx.scorecardGroups.tsgroups.length <= 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.scorecardGroups && _ctx.scorecardGroups.tsgroups)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.legendPositive) + " ", 1),
              (_ctx.showCounts)
                ? (_openBlock(), _createBlock(_component_FormattedNumber, {
                    key: 0,
                    class: "legend-number",
                    number: _ctx.totalPositiveCount
                  }, null, 8, ["number"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.legendNegative) + " ", 1),
              (_ctx.showCounts)
                ? (_openBlock(), _createBlock(_component_FormattedNumber, {
                    key: 0,
                    class: "legend-number",
                    number: _ctx.totalNegativeCount
                  }, null, 8, ["number"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Loading, {
      loading: !!_ctx.isLoadingInsightsData
    }, null, 8, ["loading"])
  ]))
}